import type { MutationHookOptions } from '@apollo/client'
import {
  ExportTrainingsDocument,
  ExportTrainingsMutation,
  ExportTrainingsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<ExportTrainingsMutation, ExportTrainingsMutationVariables>

export const useTrainingsExport = (options?: Options) => {
  const [exportTrainings, { loading }] = useMutation(ExportTrainingsDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.trainingsExportTrainingsExport,
  })

  return {
    loading,
    exportTrainings(variables: ExportTrainingsMutationVariables) {
      return exportTrainings({
        variables,
      })
    },
  }
}
